import { TableCell, TableRow } from '@windmill/react-ui';
import { FunctionComponent } from 'react';
import { useNavigate } from 'react-router-dom';

import { SolutionVersionDTO } from '../../common/api/models/solution';
import { SolutionPhaseDisplay } from './SolutionPhaseDisplay';

interface SolutionRowProps {
  solution: SolutionVersionDTO;
}

export const SolutionTableRow: FunctionComponent<SolutionRowProps> = ({
  solution,
}) => {
  const navigate = useNavigate();

  return (
    <TableRow
      data-testid={`solution-row-${solution.solutionId}`}
      key={solution.solutionId}
    >
      <TableCell className="py-6">
        <button
          className="text-brand-blue underline"
          onClick={() =>
            navigate(`/solution/${solution.solutionId}`, { replace: false })
          }
        >
          {solution.displayName}
        </button>
      </TableCell>
      <TableCell>
        <SolutionPhaseDisplay phase={solution.phase} />
      </TableCell>
    </TableRow>
  );
};
